import { render, staticRenderFns } from "./CellHeaderItem.vue?vue&type=template&id=4bbce5b8&"
import script from "./CellHeaderItem.vue?vue&type=script&lang=js&"
export * from "./CellHeaderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports